import BaseSchemaExtender from './BaseSchemaExtender';
import { getMaxLengthProperty, MAX_LENGTH_FIELD } from './maxLength';
import { getRejectLinksProperty, REJECT_LINKS_FIELD } from './rejectLinks';

// TextSchemaExtender reusa o BaseSchemaExtender e adiciona max_length e reject_links
export const TextSchemaExtender = (intl) => {
  const base = BaseSchemaExtender(intl);

  return {
    fields: [...base.fields, MAX_LENGTH_FIELD, REJECT_LINKS_FIELD],
    properties: {
      ...base.properties,
      [MAX_LENGTH_FIELD]: getMaxLengthProperty(intl),
      [REJECT_LINKS_FIELD]: getRejectLinksProperty(intl),
    },
    required: [...base.required],
  };
};

export default TextSchemaExtender;
